import { useState, useEffect } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";

const UpdateStatement = ({ SHOW, HIDE, Title, existingStatementDetails }) => {
  const [statementDetails, setStatementDetails] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    setStatementDetails(existingStatementDetails || "");
  }, [existingStatementDetails]);

  const updateStatement = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Statement!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.name = statementDetails;
        // let data = await studyAccessManagement.updateStatement(
        //   userData
        // );
        setStatementDetails("");
        HIDE();
      }
      setButtonLoader(false);
    });
  };

  return (
    <Offcanvas show={SHOW} onHide={HIDE} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group>
          <Form.Label className="mb-1 fw-bold">
            Statement Details{" "}
            <abbr title="Required" className="text-danger">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={8}
            value={statementDetails}
            placeholder="Statement Details"
            onChange={(e) => setStatementDetails(e.target.value)}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
        <button
          disabled={buttonLoader}
          onClick={updateStatement}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateStatement;
